import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { BIDDING_STATUS_TYPE } from "constants/index";

import { Row, Col, Button, Typography, Divider, Space } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import BasicCard from "./BasicCard";
import moment from "moment";

const { Title } = Typography;

const Header = ({
  setFilterVisible,
  filterParams,
  isMore = true,
  showFilterButton = true,
}) => {
  const breadcrumb = useSelector((state) => state.appReducer.breadcrumb);

  return (
    <>
      <Row gutter={[32, 24]}>
        <Col sm={24}>
          <div className="d-flex">
            <div>
              <Title style={{ display: "inline-block" }} level={5}>
                {breadcrumb.map((item, index) => {
                  return item;
                })}
              </Title>
              <Divider
                type="vertical"
                style={{ borderLeft: "2px solid #FAA634" }}
              />
            </div>
            <div style={{ flex: 1 }}>
              {filterParams && (
                <Space size={16}>
                  <BasicCard display="inline" small>
                    <span>
                      <strong>Status: </strong>
                      {filterParams?.status === 0
                        ? BIDDING_STATUS_TYPE[0].label
                        : BIDDING_STATUS_TYPE[1].label}
                    </span>
                  </BasicCard>
                  {isMore && (
                    <BasicCard
                      display="inline"
                      customClass="clickable"
                      small
                      onClick={() => setFilterVisible(true)}
                    >
                      <span>+5 more filters</span>
                    </BasicCard>
                  )}
                </Space>
              )}
            </div>
            {showFilterButton && (
              <Button
                style={{ float: "right" }}
                type="primary"
                icon={<FilterOutlined />}
                onClick={() => setFilterVisible(true)}
              >
                Filter Results
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Header;
